import AuthExpiration from './AuthExpiration';
import AuthGate, { Entitlements } from './AuthGate';
import AuthServiceProvider, {
  AuthServiceContext,
  AuthStateContext,
} from './AuthServiceProvider';
import * as hocs from './hocs';
import * as hooks from './hooks';
import fetchConfig from './fetchConfig';

// re-exports components/functions as the library's API
export {
  AuthExpiration,
  AuthGate,
  AuthServiceProvider,
  AuthServiceContext,
  AuthStateContext,
  Entitlements,
  fetchConfig,
};
export const useAuthService = hooks.useAuthService;
export const useAuthServiceUnsafe = hooks.useAuthServiceUnsafe;
export const useAuthState = hooks.useAuthState;
export const withAuthService = hocs.withAuthService;
export const withAuthState = hocs.withAuthState;
